module.exports = __webpack_public_path__ + "img/popup-bottom-battery-5.1548ac27.svg";